import {Link} from 'react-router-dom'

export function Error404() {
  return (
    <main className='education-error-page'>
      <section className='education-error-card' aria-labelledby='error-title'>
        <span className='error-code'>404</span>
        <h1 id='error-title'>Bu sayfayı bulamadık</h1>
        <p>Bağlantı değişmiş veya sayfa kaldırılmış olabilir. Sınıfınıza dönerek devam edebilirsiniz.</p>
        <div className='error-actions'>
          <Link to='/dashboard' className='btn btn-primary'>Sınıfıma dön</Link>
        </div>
      </section>
    </main>
  )
}
